export interface TimeslotTemplateListItem {
  id: string;
  day: string;
  from: string;
  to: string;
  maxOrders: number;
  maxUnits: number;
  maxDeliveryOrders: number;
  maxPickupOrders: number;
  preparationTime: number;
  deliveryTime: number;
}

export interface TimeslotTemaplatesSuccessResponse {
  timeslots: TimeslotTemplateListItem[];
}

export interface TimeslotTemplateUpdate {
  id: string;
  maxOrders: number | null;
  maxUnits: number | null;
  maxDeliveryOrders: number | null;
  maxPickupOrders: number | null;
  preparationTime: number | null;
  deliveryTime: number | null;
}

export enum TimeslotDays {
  monday = "monday",
  tuesday = "tuesday",
  wednesday = "wednesday",
  thursday = "thursday",
  friday = "friday",
  saturday = "saturday",
  sunday = "sunday",
}

export type TimeslotTemplateCreate = {
  startTime: string;
  endTime: string;
  duration: number;
  days: TimeslotDays[];
  maxOrders: number;
  maxUnits: number;
  maxDeliveryOrders: number;
  maxPickupOrders: number;
  preparationTime: number;
  deliveryTime: number;
};
